dealershipModule.factory("DealerInfo", ['imSessionVarsService', function(imSessionVarsService) {

    var DealerInfo = function() {
        this.id = '';  // IM id
        this.spanId = '';
        this.menuProId = '';
        this.name = '';
        this.accountCode = '';
        this.vehicleType ='AUTO';
        this.address = '';
        this.city = '';
        this.state = '';
        this.zip = '';
        this.phone = '';
        this.fax = '';
        this.providerLinks = '';
        this.isActive = true;
        this.altFinanceEnabled = false;
    };

    DealerInfo.prototype.convertForIdentityManagement = function() {
        var convertedDealerInfo = { };
        convertedDealerInfo.LegalName = this.name;
        convertedDealerInfo.Id = this.id;
        convertedDealerInfo.vehicleType = 'AUTO';//turning off RV for now this.vehicleType;

        convertedDealerInfo.Phones = [];
        var phone = {
            PhoneNumber : this.phone,
            Extension : null,
            CountryCode : null,
            PhoneType : 'PRIMARY'
        };

        convertedDealerInfo.Phones.push(phone);

        var fax = {
            PhoneNumber: this.fax,
            Extension: null,
            CountryCode: null,
            PhoneType: 'FAX'
        };

        convertedDealerInfo.Phones.push(fax);

        convertedDealerInfo.Addresses = [];
        var address = {
            AddressLine1 : this.address,
            AddressLine2 : null,
            City : this.city,
            CountyProvince : null,
            AddressType : 'PRIMARY',
            StateProvince : this.state,
            Country : null,
            PostalCode : this.zip
        };

        convertedDealerInfo.Addresses.push(address);

        convertedDealerInfo.IsActive = this.isActive;

        var updatedProviderLinks = null;

        if (this.providerLinks) {
            var scopedAccountCode = this.accountCode;
            // todo: get rid of this dependence on session
            var currentProviderId = imSessionVarsService.getCurrentProviderId();

            updatedProviderLinks = this.providerLinks.map(function(providerLink) {
                if(providerLink.ProviderId == currentProviderId) {
                    providerLink.accountCode = scopedAccountCode;
                }
                return providerLink;
            });
        }

        convertedDealerInfo.ProviderLinkIds = updatedProviderLinks || [];

        return convertedDealerInfo;
    };

    DealerInfo.prototype.populateDataFromIdentityManagement = function(data, callback) {
        var errorMessage = '';

        this.id = data.Id;
        this.name = data.LegalName;
        this.isActive = data.IsActive;
        this.spanId = '';
        this.menuProId = '0';
        this.vehicleType = 'AUTO';//turning off RV data.vehicleType;

        if(data.LegacyLinks) {
            var spanLink = _.find(data.LegacyLinks, function (element) {
                return element.LegacyApplication == "SPAN";
            });
            var menuProLink = _.find(data.LegacyLinks, function (element) {
                return element.LegacyApplication.toUpperCase() == "MENUPRO";
            });
            if (spanLink) {
                this.spanId = spanLink.LegacyTableId;
            }
            if (menuProLink) {
                this.menuProId = menuProLink.LegacyTableId;
            }
        }

        if (!this.spanId) {
            errorMessage = 'Error determining SPAN dealer ID: no SPAN link found. ';
        };

        errorMessage += parsePhoneData(data, this);
        errorMessage += parseFaxData(data, this);
        errorMessage += parseAddressData(data, this);
        errorMessage += parseProviderInfo(data, this);

        if(callback)
            callback(errorMessage, this);
    };

    function parsePhoneData(data, dealerInfo) {
        var errorMessage = '';
        var primaryPhoneData = data.Phones ? data.Phones.filter(function(phone) {
            return phone.PhoneType === 'PRIMARY';
        }) : [];

        if(primaryPhoneData.length !== 1 ) {
            errorMessage = "Unexpected phone number format in DB: there may have been too many or none. ";
        } else {
            dealerInfo.phone = primaryPhoneData[0].PhoneNumber;
        }

        return errorMessage;
    }

    function parseFaxData(data, dealerInfo) {
        var errorMessage = '';
        var faxPhoneData = data.Phones ? data.Phones.filter(function(phone) {
            return phone.PhoneType === 'FAX';
        }) : [];

        if(faxPhoneData.length !== 1 ) {
            errorMessage = "Unexpected fax number format in DB: there may have been too many or none. ";
        } else {
            dealerInfo.fax = faxPhoneData[0].PhoneNumber;
        }

        return errorMessage;
    }

    function parseAddressData(data, dealerInfo) {
        var errorMessage = '';

        var primaryAddressData = data.Addresses ? data.Addresses.filter(function(address){
            return address.AddressType === 'PRIMARY';
        }) : [];

        if(primaryAddressData.length !== 1) {
            errorMessage = "Unexpected address in DB: there may have been too many or none. ";
        } else {
            dealerInfo.address = primaryAddressData[0].AddressLine1;
            dealerInfo.city = primaryAddressData[0].City;
            dealerInfo.state = primaryAddressData[0].StateProvince;
            dealerInfo.zip = primaryAddressData[0].PostalCode;
        }

        return errorMessage;
    }

    function parseProviderInfo(data, dealerInfo) {
        var errorMessage = '';

        dealerInfo.providerLinks = data.ProviderLinkIds;

       // todo: get rid of this dependence on session
        var currentProviderInfo = data.ProviderLinkIds ? data.ProviderLinkIds.filter(function(linkId) {
            return linkId.ProviderId === imSessionVarsService.getCurrentProviderId();
        }) : [];

        if(currentProviderInfo.length == 0) {
            errorMessage = "Error determining account code: there may have been too many providers or none. ";
        } else {
            dealerInfo.accountCode = currentProviderInfo[0].ProviderAccountCode;
        }

        return errorMessage;
    }

    DealerInfo.prototype.addressNeedsUpdateFrom = function(dealerInfo) {
        var isDifferent = false;

        isDifferent |= dealerInfo.address !== this.address;
        isDifferent |= dealerInfo.city !== this.city;
        isDifferent |= dealerInfo.state !== this.state;
        isDifferent |= dealerInfo.zip !== this.zip;

        return isDifferent;
    };

    DealerInfo.prototype.nameNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.name !== this.name;
    };

    DealerInfo.prototype.phoneNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.phone !== this.phone;
    };

    DealerInfo.prototype.faxNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.fax !== this.fax;
    };

    DealerInfo.prototype.accountCodeNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.accountCode !== this.accountCode;
    };

    DealerInfo.prototype.isActiveNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.isActive !== this.isActive;
    };

    DealerInfo.prototype.isAltFinanceNeedsUpdateFrom = function(dealerInfo) {
        return dealerInfo.altFinanceEnabled !== this.altFinanceEnabled;
    };

    return DealerInfo;
}]);